import { render, staticRenderFns } from "./Rma.vue?vue&type=template&id=d09304f6&"
import script from "./Rma.vue?vue&type=script&lang=js&"
export * from "./Rma.vue?vue&type=script&lang=js&"
import style0 from "./Rma.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports